import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const SeoLinks = () => {
  return (
    <>
      <Swiper
        className="region-button"
        spaceBetween={10} // Space between slides
        breakpoints={{
          425: {
            slidesPerView: 2, // Show 2 slides on small screens
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4, // Show 4 slides on tablets
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4, // Show based on content on larger screens
            spaceBetween: 10,
          },
        }}
        freeMode={true} // Enable free scrolling
        style={{
          padding: "10px 0px", // Padding around text
        }}
      >
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              {/* <p className="footer-link-mainheading">Western Suburbs</p> */}
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to={"https://homesdekho.com/propertiesbyregion/Andheri"}
                  >
                    Property in Andheri
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to={"https://homesdekho.com/propertiesbyregion/Goregaon"}
                  >
                    Property in Goregaon
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to={"https://homesdekho.com/propertiesbyregion/Malad"}
                  >
                    Property in Malad
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Mulund"
                  >
                    Property in Mulund
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Vikroli"
                  >
                    Property in Vikroli
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Worli"
                  >
                    Property in Worli
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Dadar"
                  >
                    Property in Dadar
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Airoli-Ghansoli"
                  >
                    Property in Airoli
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Juinagar-Nerul-Sanpada"
                  >
                    Property in Nerul
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Kharghar"
                  >
                    Property in Kharghar
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Taloja"
                  >
                    Property in Taloja
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Panvel"
                  >
                    Property in Panvel
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Kalyan"
                  >
                    Property in Kalyan
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Dombivali"
                  >
                    Property in Dombivli
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Shahad"
                  >
                    Property in Shahad
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Ambernath"
                  >
                    Property In Ambernath
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Badlapur"
                  >
                    Property in Badlapur
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Neral"
                  >
                    Property in Neral
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Palghar"
                  >
                    Property in Palghar
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Vasai"
                  >
                    Property in Vasai
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Virar"
                  >
                    Property in Virar
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Naigaon"
                  >
                    Property in Naigoan
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Boisar"
                  >
                    Property in Boisar
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Chembur"
                  >
                    Property in Chembur
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/propertiesbyregion/Wadala"
                  >
                    Property in Wadala
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link target="_blank" to="/property-in-thane">
                    Property in Thane
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link target="_blank" to="/property-in-chinchwad">
                    Property in Chinchwad
                  </Link>
                </li>
                <li>
                  <Link target="_blank" to="/property-in-baner">
                    Property in Baner
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default SeoLinks;
